import styled, { css } from 'styled-components';
import { Row, Column } from '@simplywallst/ui-core';
import type { TransitionStatus } from 'react-transition-group/Transition';

interface TransitionWrapperProps {
  transitionStatus?: TransitionStatus;
  duration?: number;
  height?: number | null;
}

export const TransitionWrapper = styled('div')<TransitionWrapperProps>`
  overflow: hidden;
  ${({ transitionStatus, duration, height }) => {
    const transitionStyle = `height ${duration}ms ease-in-out`;
    let newHeight: string | number = 0;
    switch (transitionStatus) {
      case 'entering':
      case 'entered':
        newHeight =
          typeof height === 'undefined' || height === null
            ? 'auto'
            : `${height}px`;
        break;
      case 'exited':
      case 'exiting':
        newHeight = `0px`;
        break;
    }
    return css`
      transition: ${transitionStyle};
      height: ${newHeight};
    `;
  }}
`;

export const ListingColumn = styled(Column)`
  border-bottom: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.1)};
  padding-bottom: ${({ theme }) => theme.x1spacePx}px;
`;

export const ListingRow = styled(Row)<{ light?: boolean }>`
  padding-top: ${({ theme }) => theme.x1spacePx}px;
  background-color: ${({ theme, light }) =>
    light ? theme.color.paper : 'transparent'};
  &:hover {
    background-color: ${({ theme, light }) =>
      light ? theme.color.paperRGBA(0.9) : theme.color.darkGrayRGBA(0.1)};
  }
`;

export const UniqueSymbol = styled('p')<{ light?: boolean }>`
  margin: 0 0 0 ${({ theme }) => theme.x1spacePx}px;
  width: 100%;
  font-size: ${({ theme }) => theme.typography.tiny};
  color: ${({ theme, light }) =>
    light ? theme.color.spaceGrayRGBA(0.8) : theme.color.whiteRGBA(0.5)};
`;

export const ToggleWrapper = styled('div')`
  padding-right: 12px;
`;
